import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './app.css';
import './utils/i18n';
import CDNContainer from './container/CDNContainer';
import NPMContainer from './container/NPMContainer';
import AIContainer from './container/AIContainer';
import FeaturesContainer from './container/FeaturesContainer';
import PageCompatiblityContainer from './container/PageCompatiblityContainer';
import FeaturesDetailContainer from './container/FeaturesDetailContainer';
import ExceptionContainers from './container/ExceptionsContainer';
import DashboardApiDocumentationContainer from './container/DashboardApiDocumentationContainer';
import MicrosoftSsoIntegrationGuideContainer from './container/MicrosoftSsoIntegrationGuideContainer';

const AppShell = () => (
	<div className='app-container'>
		<Routes>
			<Route path="/" element={<CDNContainer />} />
			<Route path="/npm" element={<NPMContainer />} />
			<Route path="/ai" element={<AIContainer />} />
			<Route path="/features" element={<FeaturesContainer />} />
			<Route path="/features/:id" element={<FeaturesDetailContainer />} />
			<Route path="/documentation/:id" element={<ExceptionContainers />} />
			<Route
				path="/documentation/microsoft-sso-integration"
				element={<MicrosoftSsoIntegrationGuideContainer />}
			/>
			<Route path="/compatibility/:id" element={<PageCompatiblityContainer />} />
		</Routes>
	</div>
);

const App = () => {
	return (
		<Routes>
			<Route
				path="/documentation/dashboard-api"
				element={<DashboardApiDocumentationContainer />}
			/>
			<Route path="*" element={<AppShell />} />
		</Routes>
	);
};

export default App;
